import { render } from "./EditOrderProp.vue?vue&type=template&id=2550f582&scoped=true"
import script from "./EditOrderProp.vue?vue&type=script&lang=js"
export * from "./EditOrderProp.vue?vue&type=script&lang=js"

import "./EditOrderProp.vue?vue&type=style&index=0&id=2550f582&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2550f582"]])

export default __exports__